/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { useState } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { ArticleTeasers } from '@ta-interaktiv/react-article-teasers'
import { Timeline } from 'components/timeline'
import { TEXT_DE } from '../_text_de'
import { TEXT_FR } from '../_text_fr'

const isMobile = window.innerWidth < 600

const LOCALE = 'DE'

// TODO Set the correct article ID here
const ARTICLE_ID_DE = '707542619318'
const ARTICLE_ID_FR = '513765972314'
const ARTICLE_ID = LOCALE === 'DE' ? ARTICLE_ID_DE : ARTICLE_ID_FR

const TEXT = LOCALE === 'DE' ? TEXT_DE : TEXT_FR

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui vertical  very fitted  segment'>
        <div className='ui container'>
          <div className='ui header'>
            <h1>{TEXT.title}</h1>
            <h2>{TEXT.lead}</h2>
          </div>
        </div>
      </header>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>
              Christian Brönnimann, Svenson Cornehls
            </div>
            <div className='ta updated'>{TEXT.updated}</div>
          </div>
          <div className='ta text'>{TEXT.intro}</div>
        </div>
      </div>
      <div className='main'>
        <Timeline promises={TEXT.promises} />
      </div>
      {LOCALE === 'DE' ? (
        <Footer
          // questions={[
          //   'Wie informativ war der Beitrag?',
          //   'Wie gefällt Ihnen die Gestaltung?'
          // ]}
          articleId={ARTICLE_ID}
          credits={[
            [TEXT.credits[0], 'Christian Brönnimann'],
            [TEXT.credits[1], 'Svenson Cornehls'],
            [
              TEXT.credits[2],
              'Oliver Zihlmann, Sylvain Besson, Bernhard Odehnal'
            ]
          ]}
          mailTo='daten@tamedia.ch'
        >
          <div
            className='ui container'
            style={{ margin: isMobile ? '1.2em 0 3em' : '0 0 3em' }}
          >
            <h4 className='teaser'>Weitere Beiträge zur Credit Suisse:</h4>
            <ArticleTeasers
              numberOfCards='two'
              articleIds={['150548817033', '179152145510']}
            />
          </div>
        </Footer>
      ) : (
        <Footer
          articleId={ARTICLE_ID}
          credits={[
            [TEXT.credits[0], 'Christian Brönnimann'],
            [TEXT.credits[1], 'Svenson Cornehls'],
            [
              TEXT.credits[2],
              'Oliver Zihlmann, Sylvain Besson, Bernhard Odehnal'
            ]
          ]}
          mailTo='daten@tamedia.ch'
        >
          <div
            className='ui container'
            style={{ margin: isMobile ? '1.2em 0 3em' : '0 0 3em' }}
          >
            <h4 className='teaser'>Tout sur les Suisse Secrets</h4>
            <ArticleTeasers
              numberOfCards='three'
              articleIds={['998910987159', '270680443797', '480980625650']}
            />
          </div>
        </Footer>
      )}
    </div>
  )
}
